export default {
  messages: {
    required: 'questo é un campo obbligatorio',
    requireTrue: 'questo é un campo obbligatorio',
    phoneNumber: 'numero di telefono non valido',
    alpha: 'inserire solo caratteri alfabetici',
    email: 'email non valida',
    min: (fieldName, params) => `la ${fieldName} deve avere almeno ${params[0]} caratteri`,
    confirmed: (fieldName) => `La ${fieldName} non corrisponde a quella inserita`,
    decimal: 'Il campo accetta solo valori decimali',
    numeric: 'solo valori numerici',
    length: 'la lunghezza non è corretta',
    max: 'Il campo non può contenere più di 400 caratteri',
    min_value: (fieldName, params) => `Il campo non accetta valori minori di ${params[0]}`,
    max_value: (fieldName, params) => `Il campo può contenere valori fino ad un massimo di ${params[0]}`,
    uniqueEmail: 'email già presente nel sistema, accedi o cambia mail',
    passwordM: fieldName => `La ${fieldName} deve avere almeno 1 numero, 1 carattere maiuscolo e uno minuscolo`,
    dob18: fieldName => `18 years old`
  }
}
